/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { workloadSchemeWithBaseRangeSchema } from './workloadSchemeWithBaseRangeSchema';

export const pageResponseWorkloadSchemeWithBaseRangeSchema = z.object({
  cursor: z.string().nullish(),
  get data() {
    return z.array(workloadSchemeWithBaseRangeSchema);
  },
  hasNextPage: z.boolean().nullish(),
  recordCount: z.int().nullish(),
  recordLimit: z.int().nullish(),
});
